'use strict';

exports.__esModule = true;
/* eslint-disable */

exports.default = {
    methods: {
        touchStart: function touchStart(event) {
            this.direction = '';
            this.deltaX = 0;
            this.deltaY = 0;
            this.offsetX = 0;
            this.offsetY = 0;
            this.startX = event.touches[0].clientX;
            this.startY = event.touches[0].clientY;
        },
        touchMove: function touchMove(event) {
            var touch = event.touches[0];
            this.deltaX = touch.clientX - this.startX;
            this.deltaY = touch.clientY - this.startY;
            this.offsetX = Math.abs(this.deltaX);
            this.offsetY = Math.abs(this.deltaY);

            if (!this.direction) {
                this.direction = this.offsetX > this.offsetY ? 'horizontal' : this.offsetX < this.offsetY ? 'vertical' : '';
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tuniu/dpl-vui/lib/mixins/touch.js
// module id = 487
// module chunks = 22